import { IShare } from "@formant/core/model/IShare";

import { shareClient } from "../clients";
import { authStore } from "../stores";

export async function createTeleopShareUrl(
    deviceId: string,
    share: IShare,
): Promise<string> {
    const fullfilledShare = await shareClient.create(
        await authStore.token(),
        share,
    );

    const { code } = fullfilledShare;

    return `${origin}/${"share-teleop"}/${deviceId}/${code}`;
}
